var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('s-button',{attrs:{"theme":"is-info is-small","label":"Export","icon":"file-excel","afterIcon":"file-download"},on:{"onclick":_vm.onexport}})}
var staticRenderFns = []

export { render, staticRenderFns }